import type { GetStaticPropsContext } from 'next';

import { Icon } from '@chakra-ui/react';

import { PageCategory } from '~/features/analytics/constants';
import { TagIcon } from '~/features/experiments/ab_plp_redesign_2025/icons';
import { DEFAULT_LANGUAGE } from '~/features/internationalization/languages';
import { PageHead } from '~/features/page/components/page-head';
import { PageLayout } from '~/features/page/components/page-layout';
import { getPage } from '~/features/page/controllers/get-page';
import { Page } from '~/features/page/models/page';
import { DiscountCardLayout } from '~/features/personalized-discount/components/discount-card-layout';
import { NewUserOfferForm } from '~/features/personalized-discount/components/new-user-offer-form';

export default function PersonalizedDiscount({ page }: { page: Page }) {
  return (
    <>
      <PageHead page={page} pageCategory={PageCategory.PersonalizedDiscount} />
      <PageLayout bg='grey.50' isSimpleMode>
        <DiscountCardLayout
          headerProps={{
            icon: <Icon as={TagIcon} boxSize='18px' color='white' />,
            preTitle: 'New User Offer',
            title: 'Claim 40% OFF',
            subtitle: 'on all subscriptions and Nanodegree programs.',
          }}
        >
          <NewUserOfferForm />
        </DiscountCardLayout>
      </PageLayout>
    </>
  );
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  if (locale !== DEFAULT_LANGUAGE) {
    return {
      notFound: true,
    };
  }

  const page = await getPage('/personalized-discount');

  if (!page) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      page,
    },
  };
}
